import { useNavigate } from 'react-router-dom';
import { AlertTriangle, X, Eye } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useImpersonation } from '@/contexts/ImpersonationContext';

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedUser, endImpersonation } = useImpersonation();
  const navigate = useNavigate();

  const handleExitImpersonation = async () => {
    await endImpersonation();
    navigate('/admin/users');
  };

  if (!isImpersonating || !impersonatedUser) return null;

  const displayName = impersonatedUser.display_name 
    || `${impersonatedUser.first_name || ''} ${impersonatedUser.last_name || ''}`.trim()
    || 'Unknown User';

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-amber-950">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-12">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 bg-amber-600/30 px-3 py-1 rounded-full">
              <Eye className="h-4 w-4" />
              <AlertTriangle className="h-4 w-4" />
            </div>
            <span className="font-semibold">
              Viewing as {displayName}
            </span>
            {impersonatedUser.email && (
              <span className="text-amber-800 text-sm">
                ({impersonatedUser.email})
              </span>
            )}
          </div>

          <Button
            variant="ghost"
            size="sm"
            onClick={handleExitImpersonation}
            className="text-amber-950 hover:bg-amber-600/30 hover:text-amber-950 gap-2"
          >
            <X className="h-4 w-4" />
            Exit Impersonation
          </Button>
        </div>
      </div>
    </div>
  );
}
